import { render, staticRenderFns } from "./GpHome.vue?vue&type=template&id=4d0c2d26"
import script from "./GpHome.vue?vue&type=script&lang=js"
export * from "./GpHome.vue?vue&type=script&lang=js"
import style0 from "./GpHome.vue?vue&type=style&index=0&id=4d0c2d26&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports